import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Button } from '@synergy-marine-group/synergy-ui';
import close from '../../images/icons/cross copy.svg';
import showAlert from '../../utils/alert';
import addNewExpenseItem from './queries/addNewExpenseItem';
import compactSelectStyles from './inputStyle';
import editExpenseItem from './queries/editExpenseItem';
import CompanyAccountTable from './companyAccountTable';
import ConfirmDelete from '../Modal/ConfirmDelete';

const AddNewExpenseNew = ({ categoryList = [],
    accountCodeList = [], documentMappingList = [],
    companies, setActivePanel, editData = null, setEditData, handleUpdate
}) => {
  const categoryListWithoutPPE = categoryList.filter((item) => (item.categoryName !== 'PPE' && item.categoryName !== 'Vessel PPE'));
  const { mutate: addExpenseItem,
 isSuccess: isAddSuccess, isError: isAddError } = addNewExpenseItem();
  const { mutate: editItem, isSuccess: isEditSuccess, isError: isEditError } = editExpenseItem();
  const [form, setForm] = useState({
    expenseCategoryID: '',
    expenseLineItem: '',
    accountCodeID: '',
    courseNameId: '',
    companyId: '',
    comapanyaccountCodeID: '',
    isCourseDefault: false
  });

  const [items, setItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [formErrors, setFormErrors] = useState([]);
  const [initialForm, setInitialForm] = useState(form);
  const [initialItems, setInitialItems] = useState([]);
  const [modal, setModal] = useState(false);
  useEffect(() => {
    if (editData) {
      setSelectedCategory(editData.categoryName);
      const updatedForm = {
        expenseCategoryID: editData.expenseCategoryID || '',
        expenseLineItem: editData.expenseLineItem || '',
        accountCodeID: editData.accountCodeID || '',
        courseNameId: editData.documentIdentifier || '',
        companyId: '',
        comapanyaccountCodeID: '',
        isCourseDefault: editData.isCourseDefault || false
      };
      setInitialForm(updatedForm);
      setForm(JSON.parse(JSON.stringify(updatedForm)));
      const mappedItems = editData.companyExpenseAccountCodeList?.map((entry) => ({
        accountCode: {
          id: entry.accountCodeID,
          name: entry.accountCodeName
        },
        company: {
          id: entry.companyId,
          name: entry.companyName
        }
      })) || [];
      setItems(mappedItems);
      setInitialItems(JSON.parse(JSON.stringify(mappedItems)));
    }
  }, [editData]);
    useEffect(() => {
        if (isAddSuccess || isEditSuccess) {
          showAlert(
            `Expense Item ${editData ? 'Updated' : 'Added'} Successfully!`,
            'success'
          );
          setActivePanel(false);
          setEditData(null);
        } else if (isAddError || isEditError) {
          showAlert('Expense item already exists', 'error');
          setActivePanel(false);
          setEditData(null);
        }
      }, [isAddSuccess, isEditSuccess, isAddError, isEditError]);
  const handleChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };
  const handleAdd = () => {
    setItems([
        {
          accountCode: {
            id: '',
            name: ''
          },
          company: {
            id: '',
            name: ''
          }
        },
        ...items
      ]);
    setForm({ ...form, companyId: '', comapanyaccountCodeID: '' });
  };
  const handleSubmit = () => {
    const errors = {};
    const { accountCodeID, expenseCategoryID, expenseLineItem, courseNameId } = form;
    if (!accountCodeID) errors.accountCodeID = 'Account Code is required.';
  if (!expenseCategoryID) errors.expenseCategoryID = 'Category is required.';
  if (!expenseLineItem?.trim()) {
  errors.expenseLineItem = 'Expense Line Item is required.';
} else if (expenseLineItem.length > 40) {
  errors.expenseLineItem = 'Expense Line Item must be 40 characters or less.';
}
  if (selectedCategory === 'Training') {
    if (!courseNameId?.trim()) errors.courseNameId = 'Document is required.';
  }

  setFormErrors(errors);
  if (Object.keys(errors).length > 0) return;
  const missingCompanyOrAccountCodes = items?.filter(
    (item) => !item.company?.id || !item.accountCode?.id
  );
  if (missingCompanyOrAccountCodes.length > 0) {
    showAlert('Please select both Company and Account Code', 'error');
    return;
  }
    let payload = {
      expenseLineItem,
      expenseCategoryID,
      accountCodeID,
      documentIdentifier: courseNameId,
      companyExpenseAccountCodeList: items.map((item) => ({
        accountCodeID: item.accountCode?.id,
        companyId: item.company?.id
      })),
      ...(editData?.expenseLineItemID && { expenseLineItemID: editData.expenseLineItemID })
    };
    if (editData) {
      const isDocumentChanged = form.courseNameId !== editData.documentIdentifier;
      payload = { ...payload, isDocumentChanged };
      editItem(payload);
    } else {
      addExpenseItem(payload);
    }
  };
  const hasEmptyRow = items.some(
    (item) => !item.accountCode.id || !item.company.id
  );

  const isDisabledCheck = () => {
    const { accountCodeID, expenseCategoryID, expenseLineItem, courseNameId } = form;
    const isInvalid = !accountCodeID
    || !expenseCategoryID
    || !expenseLineItem?.trim()
    || (selectedCategory === 'Training' && !courseNameId?.trim());
    if (editData) {
      const isFormChanged = JSON.stringify(items) !== JSON.stringify(initialItems)
      || JSON.stringify(form) !== JSON.stringify(initialForm);
      return !isFormChanged || isInvalid;
    }
    return isInvalid;
  };
 return (
  <div className="flex flex-col h-screen max-h-screen no-blue-focus">
       {modal && (
            <ConfirmDelete
              {...{
                modal,
                setModal,
                handleDelete: handleSubmit
              }}
              subMessage="This change will impact the Vendor to Expense Line item mapping,
               Kindly verify the changes."
              message="Update"
            />
          )}
    <div className="overflow-y-auto flex-1 px-6 pb-28 space-y-4">
<div className="flex items-center justify-between mb-4">
  <h2 className="uppercase text-center pb-2 expense-item-header font-semibold">
  {editData ? 'EDIT EXPENSE ITEM' : 'CREATE EXPENSE ITEM'}
  </h2>
<button
  type="button"
  onClick={() => {
    setActivePanel(false);
    setEditData(null);
    }}
    className="close-btn mb-2"
>
 <img src={close} alt="EditIcon" width={13} height={13} />
</button>
</div>

<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
<label className="block mb-1 text-sm text-gray-100-item-label">
  Category
  <span className="text-red-500">*</span>
</label>
        <Select
            options={categoryListWithoutPPE?.map((item) => ({
              value: item.expenseCategoryID,
              label: item.categoryName
            }))}
            value={form.expenseCategoryID
              ? {
                  value: form.expenseCategoryID,
                  label: categoryListWithoutPPE?.find(
                    (c) => c.expenseCategoryID === form.expenseCategoryID
                  )?.categoryName
                }
              : null}
              styles={{
                ...compactSelectStyles,
                menuPortal: (base) => ({ ...base, zIndex: 99099 }),
                menu: (base) => ({ ...base, zIndex: 99099, position: 'absolute' })
              }}
            onChange={(option) => {
                const newValue = option?.value;
                setSelectedCategory(option?.label);
                handleChange('expenseCategoryID', option?.value || '');
                if (formErrors?.expenseCategoryID && newValue?.trim() !== '') {
                    setFormErrors((prev) => ({ ...prev, expenseCategoryID: null }));
                  }
            }}
        />
             {formErrors.expenseCategoryID && (
    <p className="text-red-500 text-xs mt-1">{formErrors.expenseCategoryID}</p>
  )}
        </div>
        <div>
          <label className="block mb-1 text-sm text-gray-100-item-label">
          Expense Item
          <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={form.expenseLineItem}
            maxLength={40}
            onChange={(e) => {
                const newValue = e.target?.value;
                if (newValue.length > 40) return;
                handleChange('expenseLineItem', e.target?.value);
                if (formErrors?.expenseLineItem && newValue?.trim() !== '') {
                    setFormErrors((prev) => ({ ...prev, expenseLineItem: null }));
                  }
            }}
            className="w-full border border-gray-100 rounded px-3 py-2 text-sm"
          />
               {formErrors.expenseLineItem && (
    <p className="text-red-500 text-xs mt-1">{formErrors.expenseLineItem}</p>
  )}
        </div>
        <div>
          <label className="block mb-1 text-sm text-gray-100-item-label">
          Account Code
          <span className="text-red-500">*</span>
          </label>
          <Select
            options={accountCodeList?.map((acc) => ({
              value: acc.accountCodeID,
              label: acc.accountCode
            }))}
            styles={{
                ...compactSelectStyles,
                menuPortal: (base) => ({ ...base, zIndex: 99099 }),
                menu: (base) => ({ ...base, zIndex: 99099, position: 'absolute' })
              }}
            value={form.accountCodeID
              ? {
                  value: form.accountCodeID,
                  label: accountCodeList?.find(
                  (a) => a.accountCodeID === form.accountCodeID
                  )?.accountCode
                }
              : null}
              onChange={(option) => {
                const newValue = option?.value;
                handleChange('accountCodeID', option?.value || '');
                if (formErrors?.accountCodeID && newValue?.trim() !== '') {
                  setFormErrors((prev) => ({ ...prev, accountCodeID: null }));
                }
              }}
          />
                   {formErrors.accountCodeID && (
    <p className="text-red-500 text-xs mt-1">{formErrors.accountCodeID}</p>
  )}
        </div>
<div>
  <label className="block mb-1 text-sm text-gray-100-item-label">
  Document Mapping
    {selectedCategory === 'Training'
    && <span className="text-red-500">*</span>}
  </label>
  <Select
     styles={{
        ...compactSelectStyles,
        menuPortal: (base) => ({ ...base, zIndex: 99099 }),
        menu: (base) => ({ ...base, zIndex: 99099, position: 'absolute' })
      }}
    isClearable={selectedCategory !== 'Training'}
    options={documentMappingList?.map((doc) => ({
      value: doc.documentIdentifier,
      label: doc.courseName,
      isDefault: doc.isDefault
    }))}
    value={
      form.courseNameId
        ? {
            value: form.courseNameId,
            label: documentMappingList?.find(
              (d) => d.documentIdentifier === form.courseNameId
            )?.courseName
          }
        : null
    }
    onChange={(option) => {
      handleChange('courseNameId', option?.value || '');
      handleChange('isCourseDefault', option?.isDefault);
      if (selectedCategory === 'Training' && formErrors?.courseNameId && option?.value) {
        setFormErrors((prev) => ({ ...prev, courseNameId: null }));
      }
    }}
  />
  {form.isCourseDefault && (
      <div className="text-red-500 text-xs mt-1">You selected a common document!</div>
    )}
  {selectedCategory === 'Training' && formErrors.courseNameId && (
    <p className="text-red-500 text-xs mt-1">{formErrors.courseNameId}</p>
  )}
</div>

</div>
<div className="flex items-center justify-between">
  <h6 className="company-mapping-text">COMPANY MAPPING</h6>
<button
   type="button"
   className="company-account-add-btn"
   disabled={hasEmptyRow}
   onClick={handleAdd}
>
  <span className="plus-icon text-gray-300">+</span>
  <span className="label text-gray-300">ADD</span>
</button>
</div>
<CompanyAccountTable
  validItems={items}
  items={items}
  setItems={setItems}
  editData={editData}
  companies={companies}
  accountCodeList={accountCodeList}
  compactSelectStyles={compactSelectStyles}
/>
    </div>
    <div className="sticky bottom-0 bg-white px-6 py-5 mt-2 flex justify-end gap-2">
        <Button
         type="button"
         size="small"
         variant="outlined"
         rounded
         className="w-19 text-xs h-7"
         onClick={() => {
            setActivePanel(false);
            setEditData(null);
            }}
        >
          close
        </Button>
    <button
    disabled={isDisabledCheck()}
    onClick={() => {
      if (editData) {
          handleUpdate(form, items, selectedCategory);
        } else {
        handleSubmit();
      }
    }}
        className={`uppercase tracking-wide font-montserrat font-semibold max-w-57 px-6 rounded-lg h-8 text-xs
        focus:outline-none fill-btn 
        ${isDisabledCheck()
          ? 'bg-gray-100 text-gray-500 cursor-not-allowed opacity-50'
          : 'bg-accent text-gray-100-item-label-mon hover:shadow-md active:text-white-light'}
        flex justify-center items-center`}
     type="button"
    >
    <div
    className="flex justify-center items-center"
    >
    {editData ? 'Update' : 'Save'}
    </div>
    </button>
    </div>
  </div>
);
};
export default AddNewExpenseNew;
